export default __webpack_public_path__ + "static/media/upArrowLogo.41e8e420.svg";